module.exports = __webpack_public_path__ + "static/media/header.2efe207a.jpg";